import { render, staticRenderFns } from "./OrdersAccountHeader.vue?vue&type=template&id=0e6d4c10&scoped=true&"
import script from "./OrdersAccountHeader.vue?vue&type=script&lang=js&"
export * from "./OrdersAccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAccountHeader.vue?vue&type=style&index=0&id=0e6d4c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6d4c10",
  null
  
)

export default component.exports